<template >
  <div>
    <Banner />
    <PdkHeader />
    <main>
      <div id="search_container">
        <div id="search_2">
          <div class="search-title">
            <h2>سامانه رزرواسیون پردیس داریوش کیش.</h2>
          </div>
          <div class="search-box">
            <hotel-search :hotelList="hotels" :cityList="originList" />
          </div>
        </div>
      </div>
<div class="container-fluid about-pardis-dariush">
<div class="row">
<div class="col-sm-6">
<div class="content-info">
<h3>آشنایی با پردیس داریوش کیش</h3>
<p> این مجموعه در سال 2016 و با هدف ایجاد یک سامانه مدرن گردشگری زیرمجموعه هتل بزرگ داریوش کیش تاسیس گردید . هدف ما ایجاد سامانه های کاربرپسند و سهولت دسترسی کاربران و مشتریان برای رزرو پرواز، هتل و هر موردی پیرامون گردشگری بوده است  و تمام تلاش این مجموعه ایجاد ساختاری منظم و بی عیب و نقص بوده است .  </p>
<p class="quote">
  جزیره کیش به دلیل توریستی بودن، هتل‌‌ها و اقامتگاه‌های مختلفی دارد که هر کدام دارای امکانات ویژه و منحصر‌به‌فردی هستند. در این میان یکی از هتل‌های این جزیره نه تنها یک اقامتگاه بلکه گویای بخشی از تاریخ این کشور است که در قالب یک هتل به تصویر کشیده شده و زیبایی‌های تخت جمشید را به رخ می‌کشد.

هتل داریوش کیش یکی از بزرگترین و معتبرترین هتل‌های ۵ ستاره کیش است که در میدان داریوش واقع شده و با وجود اتاق‌های متنوع و زیبا، امکانات ویژه و خدماتی عالی به یکی از بهترین هتل‌های جزیره تبدیل شده است.

</p>
</div>
</div>
<div class="col-sm-6">
<div class="row counter-item-wrapper">
<div class="col-xs-6 col-sm-6">
<div class="counter-item">
<p class="number-count-to"><span class="counter animated" data-to="113">113</span></p>
<p class="icon"><i class="fa fa-suitcase"></i></p>
<h4>Hotel Rooms</h4>
</div>
</div>
<div class="col-xs-6 col-sm-6">
<div class="counter-item">
<p class="number-count-to"><span class="counter animated" data-to="28">28</span></p>
<p class="icon"><i class="fa fa-building"></i></p>
<h4>Floors</h4>
</div>
</div>
<div class="col-xs-6 col-sm-6">
<div class="counter-item">
<p class="number-count-to"><span class="counter animated" data-to="8">8</span></p>
<p class="icon"><i class="fa fa-cutlery"></i></p>
<h4>Bars &amp; Restaurants</h4>
</div>
</div>
<div class="col-xs-6 col-sm-6">
<div class="counter-item">
<p class="number-count-to"><span class="counter animated" data-to="3">3</span></p>
<p class="icon"><i class="fa fa-sitemap"></i></p>
<h4>Meeting Rooms</h4>
</div>
</div>
</div>
</div>
</div>
</div>
      <div class="container margin_container">
        <div class="main_title">
          <h2>هتل های <span>پیشنهادی</span> ما</h2>
          <p>لیست هتل های پیشنهادی ما در ایران</p>
        </div>

        <div class="row">
          <div
            v-for="(item, index) in hotelList"
            v-bind:key="index"
            class="col-lg-3 col-md-6 wow zoomIn"
            data-wow-delay="0.1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: zoomIn;
            "
          >
            <div style="padding-bottom: 10px" class="tour_container">
              <!-- <div class="ribbon_3 popular"><span>پنج ستاره</span></div> -->
              <div class="img_container">
                <a>
                  <img
                    :src="
                      item.icon
                        ? 'data:image/jpeg;base64,' + item.icon
                        : 'img/tour_box_1.jpg'
                    "
                    width="800"
                    height="533"
                    class="img-fluid"
                    alt="image"
                  />
                  <div class="btn-add-to-hotel">
                    <button
                      @click="onSelectHotel(item)"
                      v-if="item.hotelId === 4"
                      type="button"
                      class="tooltip_flip tooltip-effect-1 btn-color btn-circle btn-xl"
                    >
                      <i class="icon-location-1"></i>

                      <span class="tooltip-content-flip"
                        ><span class="tooltip-back"
                          >انتخاب به عنوان مقصد</span
                        ></span
                      >
                    </button>
                  </div>
                  <div class="row short_info custom-short_info">
                    <div class="col-md-6">
                      <i class="icon-ok-5"></i>{{ item.title
                      }}<span class="price"> </span>
                    </div>
                    <div class="col-md-6" style="text-align: end">
                      {{ item.location.fullName }}<span class="price"> </span>
                    </div>
                  </div>
                </a>
              </div>
              <div class="custom_tour_title tour_title">
                <hotel-stars style="margin-top: -6px" />
                <span
                  style="font-size: 13px; color: black"
                  v-if="
                    !readMoreHotel[item.hotelId] && item.description.length < 90
                  "
                  >{{ item.description.split("...")[0] }}</span
                >
                <span
                  style="font-size: 13px; color: black"
                  v-if="
                    !readMoreHotel[item.hotelId] && item.description.length > 90
                  "
                  >{{ item.description.substring(0, 90) }} ...</span
                >
                <div
                  style="margin-top: 8px; text-align: justify"
                  v-if="readMoreHotel[item.hotelId]"
                >
                  {{ item.description.split("...")[1] }}
                </div>
                <span
                  style="float: left"
                  v-if="item.description.includes('...')"
                >
                  <span
                    class="read-more"
                    @click="showLessHotel(item.hotelId)"
                    v-if="readMoreHotel[item.hotelId]"
                    >بستن</span
                  >
                  <span
                    class="read-more"
                    @click="showMoreHotel(item.hotelId)"
                    v-else
                    >بیشتر بخوانید</span
                  >
                </span>
              </div>
            </div>
            <!-- End box tour -->
          </div>
          <!-- End col -->

          <div
            v-for="(item, index) in 4 - hotelList.length"
            v-bind:key="'N' + index"
            class="col-lg-3 col-md-6 wow zoomIn"
            data-wow-delay="0.1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: zoomIn;
            "
          >
            <div class="tour_container">
              <div class="img_container">
                <a>
                  <img
                    src="img/tour_box_1.jpg"
                    width="800"
                    height="533"
                    class="img-fluid"
                    alt="image"
                  />
                  <div class="custom-short_info short_info">
                    <i class="icon-ok-5"></i>هتل تست<span class="price"> </span>
                  </div>
                </a>
              </div>
              <div class="tour_title">
                <h3>هتل تست توضیحات</h3>
                <hotel-stars />
                <!-- end rating -->
                <div class="wishlist">
                  <a class="tooltip_flip tooltip-effect-1"
                    >+<span class="tooltip-content-flip"
                      ><span class="tooltip-back"
                        >انتخاب به عنوان مقصد</span
                      ></span
                    ></a
                  >
                </div>
                <!-- End wish list-->
              </div>
            </div>
            <!-- End box tour -->
          </div>
          <!-- End col -->
        </div>

        <!-- End row -->

        <!-- <p class="text-center add_bottom_30">
          <a href="all_tours_list.html" class="btn_1 medium"
            ><i class="icon-eye-7"></i>View all tours (144)
          </a>
        </p> -->
      </div>

      <div class="custom_white_bg white_bg">
        <div class="container margin_container_home">
          <div class="second-title">
            <h2>تورهای <span class="dest-list-title">پیشنهادی</span> ما</h2>
            <p>تورهای پیشنهادی ما در ایران</p>
          </div>
          <div class="container">
            <div class="">
              <div class="row">
                <!--Item-->
                <div
                  v-for="(item, index) in destinationList"
                  v-bind:key="index"
                  style="padding: 15px !important"
                  class="col-lg-4 mb-3 mb-lg-0 px-0"
                >
                  <div class="hover hover-1 text-white fullrow">
                    <img
                      style="width: 100% !important; height: 100% !important"
                      :src="
                        item.location.locationImages[0]
                          ? item.location.locationImages[0].imageUrl
                          : 'img/tour_box_1.jpg'
                      "
                    />
                    <div class="hover-overlay"></div>
                    <div
                      @click="onSelectDestination(item)"
                      class="hover-1-content px-5 py-4"
                    >
                      <span class="tooltip-content-flip"
                        ><span class="tooltip-back"
                          >انتخاب به عنوان مقصد</span
                        ></span
                      >
                      <h3 class="hover-1-title text-uppercase mb-0">
                        {{ item.title }}
                      </h3>
                      <p class="hover-1-description font-weight-light mb-0">
                        {{ item.description }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End row -->
          <br />
          <div class="banner colored">
            <div> پارک دلفین های کیش</div>
            <p>
              پارک دلفین کیش یکی از جذاب ترین و شناخته شده ترین تفریحات کیش است
              که تقریبا هر گردشگر کیش با هر نوع سن و سلیقه ای حتما این پارک زیبا
              را تجربه می کند.
            </p>
            <a href="https://dp.dariushgroup.com" class="btn_1 white">رزرو</a>
          </div>

          <!-- End row -->
        </div>
        <!-- End container -->
      </div>
    </main>
        <PdkFooter />
  </div>
</template>

<script>
import Banner from "../../components/tour/TourBanner";
import PdkHeader from "@/components/PdkHeader";
import Store from "../../views/tour/store/index";
import HotelSearch from "../../components/hotel/HotelSearch";
import PdkFooter from "@/components/PdkFooter";


require("linqjs");

export default {
  name: "Home",
  store: Store,
  components: {  Banner, PdkHeader, HotelSearch,PdkFooter},

  data: () => ({
    isResultNotFound: false,
    hotelList: [],
    hotels: [],
    originList: [],
    destinationList: [],
    specialDestination: {},
    selectedHotel: null,
    selectHotel: null,
    selectedDest: null,
    readMoreHotel: {},
    tabIndex: 1,
  }),
  async created() {
    this.getHotelList();
    this.getDestinationList();
    this.getLocationList();
  },
  computed: {
    onSelectedHotel: function () {
      return this.selectedHotel;
    },
    onSelectedDest: function () {
      return this.selectedDest;
    },
  },
  methods: {
    showMoreHotel(id) {
      this.$set(this.readMoreHotel, id, true);
    },
    showLessHotel(id) {
      this.$set(this.readMoreHotel, id, false);
    },
    onSelectHotel(item) {
      this.selectedHotel = {
        englishName: item.title,
        iata: item.location.isoCode,
        node: 0,
        order: 0,
        parentNode: 0,
        persianName: item.title,
        tags: [],
        type: "City",
      };
      return this.selectedHotel;
    },
    mapHotelItem(item) {
      const data = {
        englishName: item.title,
        iata: item.location.isoCode,
        node: 0,
        order: 0,
        parentNode: 0,
        persianName: item.title,
        tags: [],
        type: "Hotel",
      };
      return data;
    },
    mapHotelData() {
      this.hotelList.forEach((element) => {
        const data = this.mapHotelItem(element);
        this.hotels.push(data);
      });
    },

    onSelectDestination(item) {
      this.selectedDest = {
        englishName: item.title,
        iata: item.location.isoCode,
        node: 0,
        order: 0,
        parentNode: 0,
        persianName: item.title,
        tags: [],
        type: "City",
      };
    },
    async getHotelList() {
      // const loader = this.$loading.show();

      const hotels = await this.$store.dispatch("Hotel/GetHotelList");

      if (Array.isArray(hotels)) {
        this.hotelList = hotels;
        this.mapHotelData();
      }

      // loader.hide();
    },

    async getDestinationList() {
      const destinations = await this.$store.dispatch(
        "Hotel/GetDestinationList"
      );

      if (Array.isArray(destinations)) {
        this.destinationList = destinations;
        this.specialDestination = destinations.where(
          (d) => d.location.isoCode == "KIH"
        );
      }
    },
    async getLocationList() {
      this.originList = await this.$store.dispatch("getLocations");
    },
  },
};
</script>
<style lang="css" scoped>
.custom_tour_title {
  min-height: 125px !important;
}
.tooltip-content-flip .tooltip-back::after {
  left: 45%;
  border-top: 0px solid transparent !important ;
  /* border-right: 10px solid transparent; */
}
.tooltip-content-flip {
  position: absolute;
  z-index: 9999;
  width: 80px;
  height: 35px;
  right: -230% !important;
  top: 0% !important;
  text-align: center;
  color: #fff;
  opacity: 0;
  margin-top: 7px !important;
      background: #00c3e1 !important;
    border-radius: 20px;
  cursor: default;
  pointer-events: none;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: opacity 0.3s, -webkit-transform 0.3s;
  transition: opacity 0.3s, transform 0.3s;
}
.tooltip-back {
  padding: 5px;
  background: #344957;
  font-size: 12px;
  /* line-height: 14px; */
  /* padding-top: 25px; */
  -webkit-transform-origin: 0 50%;
  transform-origin: 0 50%;
  -webkit-transform: perspective(1000px) rotate3d(0, 1, 0, 90deg);
  transform: perspective(1000px) rotate3d(0, 1, 0, 90deg);
}
.img_container a img {
  height: 170px !important;
  min-height: 180px !important;
}
.custom-short_info {
  padding: 45px 0px 8px 0px !important;
  margin-left: 0px;
  padding-left: -18px;
  margin-right: 0px;
}
.btn-add-to-hotel {
  position: absolute;
  top: 0;
  right: 0;
  width: 65px;
  height: 77px;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  /* background: url(../img/badge_save.png); */
  font-size: 11px;
  line-height: 12px;
  padding-top: 10px;
  right: inherit;
  left: 0;
}
.read-more {
  font-size: 11px;
  color: #198cfb;
}
.read-more:hover {
  cursor: pointer;
  font-size: 12px;
  color: #0c79df;
}
.dest-list-title {
  color: #198cfb !important ;
}
.custom_white_bg {
  padding-top: 25px;
  padding-bottom: 15px;
}
.margin_container {
  padding-top: 1%;
  padding-bottom: 1%;
}
.cityImage {
  width: auto;
  height: auto;
}
.hover {
  overflow: hidden;
  position: relative;
  padding-bottom: 60%;
}
.fullrow {
  height: 100% !important;
}
.hover-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 90;
  transition: all 0.4s;
}

.hover img {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.3s;
  height: fit-content;
  width: fit-content !important;
}

.hover-content {
  position: relative;
  z-index: 99;
}

.hover-1 img {
  width: 105%;
  position: absolute;
  top: 0;
  left: 0%;
  transition: all 0.3s;
}

.hover-1-content {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 99;
  transition: all 0.4s;
  cursor: pointer;
}

.hover-1 .hover-overlay {
  background: rgba(213, 171, 61, 0.7);
  opacity: 0;
}

.hover-1-description {
  transform: translateY(0.5rem);
  transition: all 0.4s;
  opacity: 0;
      text-shadow: 2px 2px 1px #2a2a2a, 0px 5px 3px #20333c;
}

.hover-1:hover .hover-1-content {
  bottom: 2rem;
}

.hover-1:hover .hover-1-description {
  opacity: 1;
  transform: none;
}

.hover-1:hover img {
  left: 0;
}

.hover-1:hover .hover-overlay {
  opacity: 1;
}

.wishlist a {
  color: transparent;
  cursor: pointer;
  display: block;
}

.hover-1-content h3 {
  color: rgb(255, 240, 240);
  text-shadow: 2px 2px 1px #2a2a2a, 0px 5px 3px #20333c;
}

.btn-circle.btn-xl {
  width: 40px;
  height: 40px;
  border-radius: 35px;
  font-size: 24px;
}

.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.42857;
}

.btn-color {
  color: #fff;
  background-color: #6a9afb !important;
  border-color: #4d76c2 !important;
}

.banner div {
  font-size: 24px;
  font-weight: 500;
  line-height: 48px;
}
.banner a {
  width: 100px;
  text-align: center;
  font-size: 14px;
}
.btn_tab {
  width: 115px;
  height: 55px;
  text-align: center;
  background: #b4b3b3;
  color: #fefefe;
  border-radius: 6px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 6px;
  padding-bottom: 6px;
  font-size: 14px;
  padding-bottom: 6px;
}
.btn_tab:hover {
    background: #eeb61f;
}
.btn_tab div {
  font-size: 16px;
  text-align: center;
}
@media only screen and (min-width: 768px) {
  .col-md-2 {
    flex: 0 0 13.666% !important;
    max-width: 13.93% !important;
  }
}

@media screen and (min-width: 768px) {
  .col-md-3 {
    flex: 0 0 21% !important;
    max-width: 21% !important;
  }
}

@media (min-width: 768px) {
  .col-md-1 {
    flex: 0 0 17%;
    max-width: 17%;
  }
}

.search-title {
  text-align: center;
  margin-bottom: 4%;
  margin-top: 7%;
}
.search-title h2 {
  color: whitesmoke;
}
@media only screen and (max-width: 750px) {
.search-title h2 {
  color: whitesmoke;
  font-size: 21px;
}
}
.search-box {
  background: rgba(4, 58, 84, 0.8);
  padding: 2% 2% 3.5% 2%;
  border-radius: 10px;
  margin-bottom: 15px;
}
.highlighted-date .vpd-day-text {
  color: #ef6c00 !important;
}
.nav-margin {
  margin-left: 5px;
}
</style>
